(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var accordions = document.querySelectorAll("[data-services-accordion]");
    accordions.forEach(function (accordion) { 
      var items = accordion.querySelectorAll("[data-accordion-item]");
      if (!items.length) {
        return;
      } 

      var openItem =
        accordion.querySelector("[data-accordion-item].is-open") || items[0];

      var prefersReducedMotion = window.DNB && window.DNB.prefersReducedMotion;

      var clearPanelTransition = function (panel) {
        if (!panel || !panel._accordionTransition) {
          return;
        }
        panel.removeEventListener("transitionend", panel._accordionTransition);
        panel._accordionTransition = null;
      };

      var setItemState = function (item, isOpen, immediate) {
        var button = item.querySelector("[data-accordion-toggle]");
        var panel = item.querySelector("[data-accordion-panel]");
        var shouldSkip = immediate || prefersReducedMotion;

        if (button) {
          button.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }

        if (!panel) {
          item.classList.toggle("is-open", isOpen);
          return;
        }

        clearPanelTransition(panel);

        if (isOpen) {
          item.classList.add("is-open");
          panel.removeAttribute("hidden");
          if (shouldSkip) {
            panel.style.height = "auto";
            return;
          }
          panel.style.height = "0px";
          panel.offsetHeight;
          panel.style.height = panel.scrollHeight + "px";
          panel._accordionTransition = function (event) {
            if (event.target !== panel) {
              return;
            }
            clearPanelTransition(panel);
            panel.style.height = "auto";
          };
          panel.addEventListener("transitionend", panel._accordionTransition);
          return;
        }

        var startHeight = panel.getBoundingClientRect().height;
        item.classList.remove("is-open");
        if (shouldSkip) {
          panel.style.height = "0px";
          panel.setAttribute("hidden", "");
          return;
        }
        panel.style.height = startHeight + "px";
        panel.offsetHeight;
        panel.style.height = "0px";
        panel._accordionTransition = function (event) {
          if (event.target !== panel) {
            return;
          }
          clearPanelTransition(panel);
          panel.setAttribute("hidden", "");
        };
        panel.addEventListener("transitionend", panel._accordionTransition);
      };

      items.forEach(function (item) {
        var button = item.querySelector("[data-accordion-toggle]");
        var panel = item.querySelector("[data-accordion-panel]");
        if (!button || !panel) {
          return;
        }
        setItemState(item, item === openItem, true);
        button.addEventListener("click", function () {
          var isOpen = item.classList.contains("is-open");
          if (isOpen) {
            setItemState(item, false);
            return;
          }
          items.forEach(function (other) {
            setItemState(other, other === item);
          });
        });
      });
    });

    var spotlight = document.querySelector("[data-spotlight-clients]");
    if (!spotlight || !window.Swiper) {
      return;
    }

    var sliders = spotlight.querySelectorAll("[data-spotlight-slider]");
    if (!sliders.length) {
      return;
    }

    var normalizeString = function (value) {
      if (typeof value !== "string") {
        return "";
      }
      return value.trim();
    };

    var uniq = function (items) {
      var seen = {};
      return items.filter(function (item) {
        if (!item || seen[item]) {
          return false;
        }
        seen[item] = true;
        return true;
      });
    };

    var getUploadOrigins = function () {
      var origins = [];
      var listBase = normalizeString(spotlight.getAttribute("data-clients-base-url"));
      if (listBase) {
        origins.push(listBase);
      }

      var origin = (window.location && window.location.origin) || "";
      var host = (window.location && window.location.hostname) || "";
      var port = (window.location && window.location.port) || "";
      if (!listBase) {
        if ((host === "localhost" || host === "127.0.0.1") && port !== "44362") {
          origins.push("https://localhost:7152");
          if (origin) {
            origins.push(origin);
          }
        } else if (host.indexOf("dnbtest") !== -1) {
          origins.push("https://preprodcms.dnbtest.com");
          if (origin) {
            origins.push(origin);
          }
        } else if (origin) {
          origins.push(origin);
        }
      }
      origins.push("https://dreamsandbytes.com");
      return uniq(origins);
    };

    var uploadOrigins = getUploadOrigins();

    var resolveUploadUrl = function (path, originIndex) {
      if (!path) {
        return "";
      }
      if (/^https?:\/\//i.test(path) || path.indexOf("data:") === 0) {
        return path;
      }
      if (path.indexOf("//") === 0) {
        return (window.location ? window.location.protocol : "https:") + path;
      }
      if (path.charAt(0) === "/" && path.indexOf("/Upload/") === 0 && uploadOrigins.length) {
        var origin = uploadOrigins[Math.min(originIndex || 0, uploadOrigins.length - 1)];
        return origin.replace(/\/$/, "") + path;
      }
      return path;
    };

    var createLogoSlide = function (client) {
      var slide = document.createElement("div");
      slide.className = "swiper-slide spotlight-clients__slide";

      var logo = document.createElement("div");
      logo.className = "spotlight-clients__logo";
      slide.appendChild(logo);

      var inner = document.createElement("div");
      inner.className = "spotlight-clients__logo-inner";
      logo.appendChild(inner);

      var contentWrap = document.createElement("div");
      contentWrap.className = "spotlight-clients__logo-content";
      inner.appendChild(contentWrap);

      var name = normalizeString(client && client.name);
      var logoPath = normalizeString(client && client.logo);
      var logoHover = normalizeString(client && (client.logo_hover || client.logoHover));
      var webUrl = normalizeString(
        client && (client.webUrl || client.webURL || client.WebUrl || client.website)
      );

      if (name) {
        slide.setAttribute("aria-label", name);
      }

      var contentHost = contentWrap;
      if (webUrl) {
        var link = document.createElement("a");
        link.className = "spotlight-clients__logo-link";
        link.href = webUrl;
        if (name) {
          link.setAttribute("aria-label", name);
        }
        contentWrap.appendChild(link);
        contentHost = link;
      }

      var appendFallbackText = function () {
        if (!name) {
          return;
        }
        if (!contentHost.querySelector(".spotlight-clients__logo-text")) {
          var fallback = document.createElement("span");
          fallback.className = "spotlight-clients__logo-text";
          fallback.textContent = name;
          contentHost.appendChild(fallback);
        }
      };

      if (logoPath) {
        var img = document.createElement("img");
        img.dataset.currentPath = logoPath;
        img.dataset.originIndex = "0";
        img.src = resolveUploadUrl(logoPath, 0);
        img.alt = name || "";
        img.loading = "lazy";
        img.decoding = "async";
        img.addEventListener("error", function () {
          var currentPath = img.dataset.currentPath || "";
          var originIndex = parseInt(img.dataset.originIndex || "0", 10);
          if (currentPath.indexOf("/Upload/") === 0 && originIndex + 1 < uploadOrigins.length) {
            img.dataset.originIndex = String(originIndex + 1);
            img.src = resolveUploadUrl(currentPath, originIndex + 1);
            return;
          }
          if (currentPath === logoHover && logoPath) {
            img.dataset.currentPath = logoPath;
            img.dataset.originIndex = String(originIndex);
            img.src = resolveUploadUrl(logoPath, originIndex);
            return;
          }
          img.remove();
          appendFallbackText();
        });

        if (logoHover && logoHover !== logoPath) {
          var swapLogo = function (useHover) {
            var nextPath = useHover ? logoHover : logoPath;
            var originIndex = parseInt(img.dataset.originIndex || "0", 10);
            if (img.dataset.currentPath === nextPath) {
              return;
            }
            img.dataset.currentPath = nextPath;
            img.dataset.originIndex = String(originIndex);
            img.src = resolveUploadUrl(nextPath, originIndex);
          };
          contentHost.addEventListener("mouseenter", function () {
            swapLogo(true);
          });
          contentHost.addEventListener("mouseleave", function () {
            swapLogo(false);
          });
          contentHost.addEventListener("focus", function () {
            swapLogo(true);
          });
          contentHost.addEventListener("blur", function () {
            swapLogo(false);
          });
        }

        contentHost.appendChild(img);
      } else if (name) {
        appendFallbackText();
      }

      return slide;
    };

    var normalizeSlidesValue = function (value) {
      return typeof value === "number" && !isNaN(value) ? value : 1;
    };

    var getMaxSlidesPerView = function (options) {
      var maxValue = normalizeSlidesValue(options.slidesPerView);
      var breakpoints = options.breakpoints || {};
      Object.keys(breakpoints).forEach(function (key) {
        var entry = breakpoints[key];
        if (entry && typeof entry.slidesPerView !== "undefined") {
          var nextValue = normalizeSlidesValue(entry.slidesPerView);
          if (nextValue > maxValue) {
            maxValue = nextValue;
          }
        }
      });
      return maxValue;
    };

    var getMaxSlidesPerGroup = function (options) {
      var maxValue = normalizeSlidesValue(options.slidesPerGroup || 1);
      var breakpoints = options.breakpoints || {};
      Object.keys(breakpoints).forEach(function (key) {
        var entry = breakpoints[key];
        if (entry && typeof entry.slidesPerGroup !== "undefined") {
          var nextValue = normalizeSlidesValue(entry.slidesPerGroup);
          if (nextValue > maxValue) {
            maxValue = nextValue;
          }
        }
      });
      return maxValue;
    };

    var ensureLoopSlides = function (root, options) {
      if (!root || !options || !options.loop) {
        return;
      }
      var wrapper = root.querySelector(".swiper-wrapper");
      if (!wrapper) {
        return;
      }
      var slides = Array.prototype.slice.call(wrapper.children).filter(function (slide) {
        return (
          !slide.classList.contains("swiper-slide--clone") &&
          !slide.classList.contains("swiper-slide-duplicate")
        );
      });
      if (!slides.length) {
        return;
      }
      var maxPerView = Math.ceil(getMaxSlidesPerView(options));
      var maxPerGroup = Math.ceil(getMaxSlidesPerGroup(options));
      var loopedSlides = Math.max(maxPerView, maxPerGroup);
      var required = maxPerView + loopedSlides;
      if (!required || slides.length >= required) {
        return;
      }
      var missing = required - slides.length;
      for (var i = 0; i < missing; i += 1) {
        var clone = slides[i % slides.length].cloneNode(true);
        clone.classList.add("swiper-slide--clone");
        wrapper.appendChild(clone);
      }
    };

    var initSlider = function (slider, items, reverseDirection) {
      var track = slider.closest(".spotlight-clients__track");
      if (!items.length) {
        if (track) {
          track.style.display = "none";
        }
        return;
      }

      if (track) {
        track.style.display = "";
      }

      var wrapper = slider.querySelector(".swiper-wrapper");
      if (!wrapper) {
        return;
      }

      wrapper.innerHTML = "";
      items.forEach(function (client) {
        wrapper.appendChild(createLogoSlide(client));
      });

      var swiperOptions = {
        slidesPerView: "auto",
        spaceBetween: 50,
        speed: 6000,
        loop: true,
        allowTouchMove: true,
        grabCursor: true,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          reverseDirection: reverseDirection
        }
      };

      ensureLoopSlides(slider, swiperOptions);

      new window.Swiper(slider, swiperOptions);
    };

    // console.log("[loader] fetch start", "/Client-service");
    var request = fetch("/Client-service")
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Client data not found");
        }
        return response.json();
      })
      .then(function (data) {
        var rawPayload = Array.isArray(data) ? data : data.data;
        // console.log("[loader] fetch success", "/Client-service", {
        //   items: Array.isArray(rawPayload) ? rawPayload.length : null
        // });
        var payload = Array.isArray(data) ? data : data.data;
        if (!Array.isArray(payload) || !payload.length) {
          return;
        }

        var splitIndex = Math.ceil(payload.length / 2);
        var firstHalf = payload.slice(0, splitIndex);
        var secondHalf = payload.slice(splitIndex);

        sliders.forEach(function (slider, index) {
          var reverse = slider.getAttribute("data-spotlight-direction") === "reverse";
          var items = index % 2 === 0 ? firstHalf : secondHalf;
          initSlider(slider, items, reverse);
        });
      })
      .catch(function (error) {
        // console.log("[loader] fetch failed", "/Client-service", error);
        sliders.forEach(function (slider) {
          var track = slider.closest(".spotlight-clients__track");
          if (track) {
            track.style.display = "none";
          }
        });
      });

    if (window.DNB && typeof window.DNB.registerLoadTask === "function") {
      window.DNB.registerLoadTask(request);
    }
  });
})();
